<template>
  <div id="wash-screen">
    <div class="component-wrapper">
      <transition name="fade" mode="out-in">
        <component
          :is="currentComponent.component.is"
          v-bind="currentComponent.component"
          v-on="currentComponent.component.on"
        ></component>
      </transition>
    </div>
    <div class="footer">
      <div class="back-button">
        <rounded-button
          height="30px"
          position="left"
          :isOutline="true"
          @click="showBackPage"
          v-if="currentScreenIndex !== 0"
        >
          {{ $t("washScreen.footer.back") }}
        </rounded-button>
      </div>
      <div class="next-button">
        <rounded-button
          height="30px"
          position="right"
          @click="showNextPage"
          :disabled="calculateButtonType"
          v-if="currentScreenIndex !== 1"
        >
          {{ $t("washScreen.footer.next") }}
        </rounded-button>
        <rounded-button
          height="30px"
          position="right"
          :isOutline="false"
          @click="saveMoving"
          :disabled="saveButtonType"
          v-if="currentScreenIndex === 1"
        >
          {{ $t("washScreen.footer.save") }}
        </rounded-button>
      </div>
    </div>
  </div>
</template>

<script>
import BoxReader from "@/components/shared/BoxReader";
import WashSummaryScreen from "@/components/modules/Wash/WashSummaryScreen";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "WashScreen",
  props: {},
  components: {},
  data: () => ({
    currentScreenIndex: 0
  }),
  created() {
    this.currentScreenIndex = this.initScreen();
  },
  computed: {
    ...mapGetters({
      getQR: "moving/getQR",
      getWithKeyBoard: "moving/getWithKeyBoard"
    }),
    detectMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];

      return toMatch.some(toMatchItem => {
        return navigator.userAgent.match(toMatchItem);
      });
    },
    computedData() {
      const data = {};
      if (this.getQR.length > 0) {
        data["boxQRs"] = this.getQR;
        data["withKeyBoardQRs"] = this.getWithKeyBoard;
        data["moved"] = 0;
        data["isMobile"] = this.detectMobile;
      }

      return data;
    },
    saveButtonType() {
      return !("boxQRs" in this.computedData);
    },
    calculateButtonType() {
      if (this.currentScreenIndex === 0) {
        return this.getQR.length === 0;
      }
      return false;
    },
    currentComponent() {
      return this.screens[this.currentScreenIndex];
    },
    screens() {
      return [
        {
          component: { is: BoxReader }
        },
        {
          component: { is: WashSummaryScreen }
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      createMovement: "movements/createMovement",
      removeMoving: "moving/removeMoving"
    }),
    saveMoving() {
      this.createMovement(this.computedData)
        .then(res => {
          if (res.status === "OK") {
            this.removeMoving();
            this.currentScreenIndex = 0;
            this.$notification.showNoti(
              "success",
              "washScreen.saveMovement.success"
            );
          } else {
            this.$notification.showNoti("error", null, res);
          }
        })
        .catch(() => {
          this.$notification.showNoti("error", "washScreen.saveMovement.error");
        });
    },
    initScreen() {
      const qrObj = this.getQR;
      if (qrObj.length === 0) {
        return 0;
      } else {
        return 1;
      }
    },
    showBackPage() {
      this.currentScreenIndex -= 1;
    },
    showNextPage() {
      this.currentScreenIndex += 1;
    }
  }
};
</script>

<style lang="scss" scoped>
#wash-screen {
  .footer {
    display: flex;
    padding-bottom: 20px;
    margin: auto;
    max-width: 500px;
    /deep/ #rounded-button-wrapper {
      white-space: nowrap;
      min-width: 130px;
      max-width: 200px;
    }
    .back-button {
      width: 50%;
      padding-right: 10px;
    }
    .next-button {
      padding-left: 10px;
      width: 50%;
    }
  }
}
</style>
